import { useMutation } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { LeadItem } from 'lib/context/types';
import { useGTMAnalytics } from 'lib/hooks/GTM/useGTMAnalytics';
import { useTranslation } from 'react-i18next';

export interface CreateLeadParams extends Partial<LeadItem> {
  disableToast?: boolean;
}

export const createLead = async (data: CreateLeadParams) => {
  const response = await EXPRESS_API.post(`/leads`, data);
  return response.data;
};

export const useAddLeadMutation = () => {
  const { t } = useTranslation();
  const { trackGTMNewLeadAddedEvent } = useGTMAnalytics();

  return useMutation(createLead, {
    onSuccess: (lead, options) => {
      trackGTMNewLeadAddedEvent?.({ customerId: lead.leadId });
      if (!options.disableToast) {
        successToast({
          title: t('You created a new customer!'),
        });
      }
    },
    onError: () => {
      errorToast({ title: t('An error occurred while creating lead.') });
    },
  });
};
